import React, { createContext, useContext, useState } from "react"

const HeaderContext = createContext()

export const HeaderProvider = ({ children }) => {
    const [customPhone, setCustomPhone] = useState(null)

    return (
        <HeaderContext.Provider value={{ customPhone, setCustomPhone }}>
            {children}
        </HeaderContext.Provider>
    )
}

export const useHeader = () => useContext(HeaderContext)

export default HeaderContext
